import { LabelColumn } from './label-column';
import { LabelHeaderColumn } from './label-header-column';
import { YesNoColumn } from './yes-no-column';
import { YesNoColumnComponent } from './yes-no-column.component';
import { YesNoHeader } from './yes-no-header';
import { FormField } from '../../common/register/form-field';
import { FormFieldColumnComponent } from '../../common/register/form-field-column/form-field-column.component';

export class YesNo extends FormField {
  constructor(item, header: YesNoHeader) {
    super(item, header);

    this.grid = [
      header.columns.map((headerColumn) => {
        return headerColumn instanceof LabelHeaderColumn
          ? new LabelColumn(item, FormFieldColumnComponent)
          : new YesNoColumn(item, YesNoColumnComponent);
      }),
    ];
  }
}
